(() => {
  const enhanceCategoryFaqs = () => {
    document.querySelectorAll('.category-guide__content, .category-guide').forEach((root, rootIndex) => {
      if (root.dataset.heargoodFaqEnhanced === 'true') return;

      root.querySelectorAll(':scope > table').forEach((table) => {
        if (table.parentElement?.classList.contains('table-wrapper')) return;
        const wrapper = document.createElement('div');
        wrapper.className = 'table-wrapper';
        table.before(wrapper);
        wrapper.append(table);
      });

      root.querySelectorAll(':scope > .table-wrapper').forEach((wrapper) => {
        let candidate = wrapper.previousElementSibling;
        let steps = 0;
        while (candidate && steps < 3 && !/^H[2-4]$/.test(candidate.tagName)) {
          candidate = candidate.previousElementSibling;
          steps += 1;
        }
        if (candidate && /^H[2-4]$/.test(candidate.tagName)) {
          candidate.classList.add('category-guide__table-heading');
          let intro = candidate.nextElementSibling;
          while (intro && intro !== wrapper) {
            if (intro.tagName === 'P') {
              intro.classList.add('category-guide__table-intro');
            }
            intro = intro.nextElementSibling;
          }

          if (candidate.tagName !== 'H2') {
            let earlier = candidate.previousElementSibling;
            let earlierSteps = 0;
            while (earlier && earlierSteps < 3) {
              if (earlier.tagName === 'P') {
                earlier.classList.add('category-guide__table-intro');
              }
              if (earlier.tagName === 'H2') {
                earlier.classList.add('category-guide__table-heading');
                break;
              }
              earlier = earlier.previousElementSibling;
              earlierSteps += 1;
            }
          }
        }
      });

      const tableWrapper = root.querySelector(':scope > .table-wrapper');
      if (tableWrapper) {
        let intermediate = tableWrapper.nextElementSibling;
        while (intermediate) {
          if (
            intermediate.classList.contains('category-guide__faq') ||
            (intermediate.tagName === 'H2' && /^Häufige Fragen/i.test(intermediate.textContent.trim()))
          ) {
            break;
          }
          if (/^H[2-4]$/.test(intermediate.tagName)) {
            intermediate.classList.add('category-guide__intermediate-heading');
          } else if (['P', 'UL', 'OL'].includes(intermediate.tagName)) {
            intermediate.classList.add('category-guide__intermediate-content');
          }
          intermediate = intermediate.nextElementSibling;
        }
      }

      const heading = Array.from(root.children).find((element) =>
        element.tagName === 'H2' && /^Häufige Fragen/i.test(element.textContent.trim())
      );
      if (!heading) return;

      const pairs = [];
      let current = heading.nextElementSibling;
      while (current && current.tagName === 'H3') {
        const answer = current.nextElementSibling;
        if (!answer || answer.tagName !== 'P') break;
        pairs.push({ question: current, answer });
        current = answer.nextElementSibling;
      }
      if (!pairs.length) return;

      const section = document.createElement('section');
      const list = document.createElement('div');
      const headingId = `category-guide-faq-${rootIndex + 1}`;
      section.className = 'category-guide__faq';
      section.setAttribute('aria-labelledby', headingId);
      list.className = 'category-guide__faq-list';
      heading.id = headingId;

      heading.before(section);
      section.append(heading, list);

      pairs.forEach(({ question, answer }) => {
        const item = document.createElement('details');
        const summary = document.createElement('summary');
        item.className = 'category-guide__faq-item';
        summary.textContent = question.textContent.trim();
        answer.classList.add('category-guide__faq-answer');
        item.append(summary, answer);
        list.append(item);
        question.remove();
      });

      root.dataset.heargoodFaqEnhanced = 'true';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceCategoryFaqs, { once: true });
  } else {
    enhanceCategoryFaqs();
  }
})();
